import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { enrich } from '@i18n/localizeHelper'
import { InitiativesPanel } from './sections/shared/InitiativesPanel'
import useMediaQuery from '@app/util/useMediaQuery'
import { useUserContext } from '@app/util/hooks/useUserContext'
import peopleDreaming from '@app/assets/images/people_dreaming.png'
import { styled } from 'inlines'
import { Image } from '@app/components/core/image/Image'

export const ProfileHome = () => {
  const isMobile = useMediaQuery()
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.home

  const { user } = useUserContext()
  const firstName = user?.firstName ?? 'Anon'

  return (
    <DashboardPageLayout gap="0">
      <Title.H3>{enrich(translations.title, firstName)}</Title.H3>
      <Row gap="1.5rem" style={{ alignItems: 'center', flexWrap: 'wrap' }}>
        <Column
          alignItems="center"
          gap="1rem"
          style={{
            paddingRight: isMobile ? 0 : '5rem',
            flex: '1 1 30rem',
            minWidth: '10rem',
          }}
        >

        <Image
          src={peopleDreaming}
          alt=""
          resizeWidth={336}
          style={{
            width: '21rem',
            height: 'auto',
            padding: '1rem',
          }}
        />
          <Title.H4 style={{ alignSelf: 'center' }}>{translations.welcome}</Title.H4>
          <Text.Medium style={{ textAlign: 'center', whiteSpace: 'pre-line' }}>
            {translations.updatesPlaceholder}
          </Text.Medium>
        </Column>
        <InitiativesPanel />
      </Row>
    </DashboardPageLayout>
  )
}
